export const closeCopilotChatDrawer = "HQYKYc";
export const expandCopilotChatDrawer = "HNFvPd";
export const collapseCopilotChatDrawer = "gtb6Ad";
export default {closeCopilotChatDrawer,expandCopilotChatDrawer,collapseCopilotChatDrawer};